import { Spinner } from "@/components/ui";
import { AuthPageLayout } from "./auth-page-layout";
import { useT } from "@/i18n";
import { authMessages } from "@/i18n/messages/auth";

interface AuthLoadingStateProps {
  label?: string;
}

export function AuthLoadingState({ label }: AuthLoadingStateProps) {
  const t = useT(authMessages);
  return (
    <AuthPageLayout>
      <div
        className="flex items-center justify-center py-3"
        data-testid="auth-loading"
        role="status"
      >
        <Spinner className="h-8 w-8" />
        <span className="sr-only">{label ?? t("loadingAuth")}</span>
      </div>
    </AuthPageLayout>
  );
}
